import * as preact from "preact";

import UserWordModel from "models/UserWordModel";
import * as practiceUtils from "practiceUtils";

interface State {}

class DefaultChallengeView extends preact.Component<
  practiceUtils.ChallengeProps,
  State
> {
  userWords: Backbone.Collection<UserWordModel>;

  render() {
    return <div>Challenge type not implemented</div>;
  }
}

export default DefaultChallengeView;
